// extracted by css-extract-rspack-plugin
export default {"cls1":"RotatingPreview-cls1_ZZ0","cls2":"RotatingPreview-cls2_zHD RotatingPreview-cls1_ZZ0"};